export const BUILD_VERSION = process.env.BUILD_VERSION
export const TIMELINE_HEIGHT = 32
export const TOOLBAR_HEIGHT = 32
export const MOUSE_WHEEL_DISTANCE_FACTOR = 1.8
